export default "/build/images/draft.png?210f324337b02326094386300538326a";